module.exports = __webpack_public_path__ + "img/why-icon-5.1f7fe1d2.svg";